// @ts-nocheck
import React, { useState, useEffect, useRef, useMemo, useCallback, memo } from "react";
import {
  Play,
  Info,
  X,
  Bell,
  Search,
  ChevronDown,
  Plus,
  Check,
  ThumbsUp,
  Volume2,
  VolumeX,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

/* -------------------------------------------------------------------------- */
/*                                Data Source                                 */
/* -------------------------------------------------------------------------- */

const PORTFOLIO_DATA = [
  {
    id: 1,
    title: "CAFE nanairo",
    originalTitle: "カフェのLP",
    genre: "Webデザイン",
    category: "Web",
    match: "99% マッチ",
    rating: "All",
    duration: "LP",
    url: "https://nozomi-cafe-nanairo.netlify.app",
    image: "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?auto=format&fit=crop&w=1600&q=80",
    description: "画面から漂うコーヒーの香り。五感を刺激するデザインが織りなす、心温まるカフェのランディングページ。",
    cast: ["Parallax", "Animation", "Branding"],
    tags: ["癒し", "デザイン", "アート"],
  },
  {
    id: 2,
    title: "SKETCH FARM",
    originalTitle: "マイクロハーブLP",
    genre: "アグリテック",
    category: "Web",
    match: "98% マッチ",
    rating: "All",
    duration: "LP",
    url: "https://n-sketch-farm.netlify.app",
    image: "https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=1600&q=80",
    description: "都市型農業の新しい形。マイクロハーブの魅力を最大限に引き出し、消費者に直接届けるためのプロモーションサイト。",
    cast: ["UI/UX Design", "Responsive", "Visual Storytelling"],
    tags: ["農業", "エコ", "ライフスタイル"],
  },
  {
    id: 3,
    title: "Micro Herb Delivery",
    originalTitle: "マイクロハーブApp",
    genre: "受発注システム",
    category: "App",
    match: "97% マッチ",
    rating: "B2B",
    duration: "App",
    url: "https://liff.line.me/2010021938-R9EhB5rj",
    adminUrl: "https://n-sketch-r.github.io/nanairo-app/admin.html",
    image: "https://images.unsplash.com/photo-1556740714-a8395b3bf30f?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80",
    description: "LINE LIFFを活用した顧客向け受発注アプリと、効率的な管理画面を統合。受発注の煩雑なフローをシームレスに解決。",
    cast: ["LINE LIFF", "Order Management", "Admin Dashboard"],
    tags: ["DX", "効率化", "B2B"],
  },
  {
    id: 4,
    title: "Visual Journey",
    originalTitle: "写真、動画ポートフォリオ",
    genre: "クリエイティブ",
    category: "Web",
    match: "96% マッチ",
    rating: "Art",
    duration: "Gallery",
    url: "https://portfolio-1vc.pages.dev/",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1600&q=80",
    description: "一瞬の光を切り取る。映像と写真が織りなす圧倒的なビジュアル体験をまとめた、クリエイターとしての集大成。",
    cast: ["Video Production", "Photography", "Creative Direction"],
    tags: ["アート", "映像", "クリエイティブ"],
  },
  {
    id: 5,
    title: "オーダー：食の未来",
    originalTitle: "社員食堂のモバイルオーダー",
    genre: "フード・システム",
    category: "System",
    match: "95% マッチ",
    rating: "All",
    duration: "System",
    url: "https://mobileordering.netlify.app",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=1600&q=80",
    description: "行列に並ぶ時代は終わった。テクノロジーが社食のスタイルを変革する。スマートな注文体験がもたらす、新しい日常。",
    cast: ["Mobile Order", "Payment Integration", "Real-time UI"],
    tags: ["効率化", "ライフスタイル", "イノベーション"],
  },
  {
    id: 6,
    title: "タイム・マネー",
    originalTitle: "タイムカード",
    genre: "HR・システム",
    category: "System",
    match: "94% マッチ",
    rating: "Biz",
    duration: "System",
    url: "https://timecardts.netlify.app/",
    image: "https://images.unsplash.com/photo-1495364141860-b0d03eccd065?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1600&q=80",
    description: "時は金なり。正確な時を刻むクラウドシステムが、人々の働き方を根本から変えていく。シンプルな勤怠管理。",
    cast: ["Time Tracking", "HR Tech", "Simple UI"],
    tags: ["時間", "テクノロジー", "社会"],
  },
  {
    id: 7,
    title: "ヒューマン・リソース",
    originalTitle: "人事ポータブル",
    genre: "HR・ポータル",
    category: "System",
    match: "93% マッチ",
    rating: "Biz",
    duration: "System",
    url: "https://human-resourcests.netlify.app",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1600&q=80",
    description: "点在する人事データを一つに。従業員体験（EX）を向上させるための、次世代型HRポータルダッシュボード。",
    cast: ["Portal UI", "Data Management", "Employee Experience"],
    tags: ["人事", "マネジメント", "DX"],
  },
  {
    id: 8,
    title: "ゲートキーパー",
    originalTitle: "面会受付",
    genre: "セキュリティ",
    category: "System",
    match: "92% マッチ",
    rating: "All",
    duration: "System",
    url: "https://visitation-reception.netlify.app",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1600&q=80",
    description: "完璧なセキュリティと最高のおもてなし。訪問者をスムーズに迎えるデジタルインターフェースの裏側に隠された洗練されたロジック。",
    cast: ["QR Code", "Guest Management", "Tablet UI"],
    tags: ["テクノロジー", "セキュリティ", "近未来"],
  },
  {
    id: 9,
    title: "ホワイト・ウォーズ",
    originalTitle: "経営ダッシュボード",
    genre: "データビジュアライゼーション",
    category: "System",
    match: "91% マッチ",
    rating: "Pro",
    duration: "System",
    url: "https://bedcontrol.netlify.app",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1504813184591-01572f98c85f?auto=format&fit=crop&w=1600&q=80",
    description: "命の現場、あるいはビジネスの最前線を数字で支える。複雑なデータを直感的に把握可能にする経営ダッシュボードの最適解。",
    cast: ["Dashboard", "Analytics", "Data Visualization"],
    tags: ["戦略", "マネジメント", "インテリジェンス"],
  },
  {
    id: 10,
    title: "BOSTON RUN",
    originalTitle: "ボストンテリアラン",
    genre: "ゲーム・アクション",
    category: "Game",
    match: "99% マッチ",
    rating: "Cute",
    duration: "Endless",
    url: "https://bostonrun.netlify.app",
    image: "https://images.unsplash.com/photo-1543466835-00a7907e9de1?auto=format&fit=crop&w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?auto=format&fit=crop&w=1600&q=80",
    description: "元気いっぱいのボストンテリアが駆け抜ける！反射神経が試される、思わず夢中になってしまうエンドレスラン・ゲーム。",
    cast: ["Game Logic", "Canvas API", "High Performance"],
    tags: ["スリル", "キュート", "没入型体験"],
  }
];

/* -------------------------------------------------------------------------- */
/*                                Components                                  */
/* -------------------------------------------------------------------------- */

const IntroAnimation = memo(({ onComplete }) => {
  const [zoom, setZoom] = useState(false);
  useEffect(() => {
    const zoomTimer = setTimeout(() => setZoom(true), 2200);
    const completeTimer = setTimeout(onComplete, 4500);
    return () => { clearTimeout(zoomTimer); clearTimeout(completeTimer); };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center overflow-hidden">
      <div
        className={`relative flex items-center justify-center transition-all duration-[2000ms] cubic-bezier(0.6, 0.05, 0.2, 1) ${
          zoom ? "scale-[60] opacity-0" : "scale-100 opacity-100"
        }`}
        style={{ width: "30vmin", height: "30vmin" }}
      >
        <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
          <defs>
            <filter id="shadow">
              <feDropShadow dx="1" dy="1" stdDeviation="2" floodColor="black" floodOpacity="0.5" />
            </filter>
            <linearGradient id="redGradient" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#e50914" />
              <stop offset="100%" stopColor="#b20710" />
            </linearGradient>
          </defs>
          <g>
            <path d="M 50 15 L 20 90 L 40 90 L 60 25 Z" fill="url(#redGradient)" style={{ filter: "url(#shadow)" }} />
            <path d="M 50 15 L 80 90 L 60 90 L 40 25 Z" fill="#8a050b" style={{ filter: "url(#shadow)" }} />
            <path d="M 32 65 L 68 65 L 66 75 L 34 75 Z" fill="#e50914" style={{ filter: "url(#shadow)" }} />
          </g>
        </svg>
      </div>
    </div>
  );
});

const ProfileSelect = memo(({ onSelect }) => {
  const profiles = [
    { id: 'aizawa', name: 'AIZAWA', seed: 'Aizawa', color: 'bg-[#e5b109]' },
    { id: 'guest', name: '面接官', seed: 'Guest', color: 'bg-[#e50914]' },
    { id: 'kids', name: 'キッズ', seed: 'Kids', color: 'bg-blue-500' }
  ];

  return (
    <div className="fixed inset-0 z-[90] bg-[#141414] flex flex-col items-center justify-center animate-fade-in text-center">
      <h1 className="text-white text-3xl md:text-5xl font-medium mb-8 md:mb-12">誰が観ますか?</h1>
      <div className="flex gap-4 md:gap-8 items-start justify-center flex-wrap px-4">
        {profiles.map(p => (
          <div key={p.id} className="group flex flex-col items-center gap-2 cursor-pointer" onClick={onSelect}>
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-md overflow-hidden border-2 border-transparent group-hover:border-white transition">
              <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${p.seed}`} alt={p.name} className={`w-full h-full ${p.color}`} loading="lazy" />
            </div>
            <span className="text-gray-400 group-hover:text-white transition text-lg">{p.name}</span>
          </div>
        ))}
      </div>
      <button className="mt-12 md:mt-16 border border-gray-400 text-gray-400 px-6 py-2 hover:border-white hover:text-white transition uppercase tracking-widest text-sm md:text-base">
        プロフィールの管理
      </button>
    </div>
  );
});

const LoadingScreen = memo(() => (
  <div className="fixed inset-0 z-[100] bg-[#141414] flex items-center justify-center">
    <div className="w-16 h-16 border-4 border-transparent border-t-[#e50914] rounded-full animate-spin"></div>
  </div>
));

const Navbar = memo(({ scrolled, activeCategory, onCategoryChange }) => {
  const categories = ["ホーム", "業務システム (SaaS)", "Web・LP制作", "アプリ・ゲーム"];

  return (
    <nav className={`fixed top-0 w-full z-40 transition-all duration-500 ${scrolled ? "bg-[#141414]" : "bg-gradient-to-b from-black/80 via-black/40 to-transparent"}`}>
      <div className="flex items-center justify-between px-[4%] h-[68px]">
        <div className="flex items-center gap-8 md:gap-12">
          <h1 
            className="text-[#e50914] text-2xl md:text-3xl font-black tracking-tighter cursor-pointer select-none"
            style={{ fontFamily: "Arial Black, sans-serif", textShadow: "0 0 10px rgba(0,0,0,0.5)" }}
            onClick={() => onCategoryChange("ホーム")}
          >
            AIZAWA
          </h1>
          <ul className="hidden lg:flex gap-5 text-sm font-normal items-center">
            {categories.map(cat => (
              <li 
                key={cat}
                onClick={() => onCategoryChange(cat)}
                className={`cursor-pointer transition ${activeCategory === cat ? "text-white font-bold" : "text-[#e5e5e5] hover:text-[#b3b3b3]"}`}
              >
                {cat}
              </li>
            ))}
          </ul>
          <div className="lg:hidden flex items-center text-white text-sm font-bold gap-1 cursor-pointer">
            <span>メニュー</span><ChevronDown className="w-4 h-4" />
          </div>
        </div>
        <div className="flex items-center gap-6 text-white">
          <Search className="w-6 h-6 cursor-pointer hover:text-gray-300 transition" />
          <span className="hidden md:block text-sm text-white cursor-pointer hover:text-gray-300">キッズ</span>
          <div className="relative cursor-pointer hover:text-gray-300 transition">
            <Bell className="w-6 h-6" />
            <div className="absolute -top-1 -right-1 bg-red-600 text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full text-white border border-[#141414]">13</div>
          </div>
          <div className="flex items-center gap-2 cursor-pointer group">
            <div className="w-8 h-8 rounded bg-yellow-500 overflow-hidden border border-transparent group-hover:border-white transition">
              <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Aizawa" alt="Profile" loading="lazy" />
            </div>
            <ChevronDown className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
          </div>
        </div>
      </div>
    </nav>
  );
});

const HeroBillboard = memo(({ items, onInfoClick, isMuted, toggleMute }) => {
  const slideshowItems = useMemo(() => items.slice(0, 4), [items]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentItem = slideshowItems[currentIndex] || items[0];

  useEffect(() => {
    if (!slideshowItems.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slideshowItems.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [slideshowItems.length]);

  if (!currentItem) return null;

  return (
    <div className="relative w-full h-[140vw] md:h-[95vh] text-white overflow-hidden group bg-[#000]">
      <div className="absolute top-0 left-0 w-full h-full">
        <div key={currentItem.id} className="absolute inset-0 w-full h-full animate-billboard-fade-in">
          <img src={currentItem.heroImage} alt={currentItem.title} className="w-full h-full object-cover animate-slow-zoom origin-center" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#141414]/90 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 w-full h-[40vh] bg-gradient-to-t from-[#141414] via-[#141414]/60 to-transparent"></div>
        </div>
      </div>
      <div className="absolute bottom-[25%] md:bottom-[35%] left-4 md:left-[4%] max-w-xl z-10">
        <div key={`text-${currentItem.id}`} className="animate-fade-in-up">
          <div className="flex items-center gap-2 mb-2 md:mb-4">
            <div className="flex items-center">
              <span className="text-[#e50914] font-black text-3xl tracking-tighter mr-1" style={{ fontFamily: "Arial Black, sans-serif" }}>A</span>
              <span className="text-gray-200 text-lg md:text-xl font-bold tracking-[0.2em] drop-shadow-md">SERIES</span>
            </div>
          </div>
          <h1 className="text-3xl md:text-6xl font-black mb-4 drop-shadow-2xl leading-tight tracking-tight text-white uppercase" style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}>
            {currentItem.title}
          </h1>
          <p className="hidden md:block text-lg text-white mb-6 drop-shadow-md line-clamp-3 font-medium text-shadow-md leading-relaxed">
            {currentItem.description}
          </p>
          <div className="flex items-center gap-3 md:gap-4 mt-4">
            <a href={currentItem.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-white text-black px-6 py-2 md:px-8 md:py-3 rounded md:rounded-md md:text-xl font-bold hover:bg-white/90 transition active:scale-95 shadow-lg">
              <Play className="fill-black w-6 h-6 md:w-8 md:h-8" />
              <span>再生</span>
            </a>
            <button onClick={() => onInfoClick(currentItem)} className="flex items-center gap-2 bg-[rgba(109,109,110,0.7)] text-white px-6 py-2 md:px-8 md:py-3 rounded md:rounded-md md:text-xl font-bold hover:bg-[rgba(109,109,110,0.5)] transition active:scale-95 shadow-lg backdrop-blur-sm">
              <Info className="w-6 h-6 md:w-8 md:h-8" />
              <span>詳細情報</span>
            </button>
          </div>
        </div>
      </div>
      <div className="absolute bottom-[30%] md:bottom-[40%] right-0 z-20 flex items-center gap-4">
        <button onClick={toggleMute} className="border border-gray-400/50 rounded-full p-2 mr-4 md:mr-[4%] bg-black/30 hover:bg-black/50 hover:border-white transition backdrop-blur-sm">
          {isMuted ? <VolumeX className="w-5 h-5 text-white" /> : <Volume2 className="w-5 h-5 text-white" />}
        </button>
      </div>
    </div>
  );
});

const Row = memo(({ title, items, isRanking, onCardClick, toggleMyList, myList }) => {
  const scrollRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = window.innerWidth * 0.8;
      scrollRef.current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="mb-8 md:mb-12 relative group/row px-4 md:px-[4%]">
      <h2 
        onClick={() => setIsExpanded(!isExpanded)}
        className="text-[#e5e5e5] text-lg md:text-xl font-bold mb-3 md:mb-4 cursor-pointer hover:text-white transition inline-flex items-center gap-2 group-hover/row:translate-x-1 duration-300"
      >
        {title}
        <span className="text-xs text-[#54b9c5] opacity-0 group-hover/row:opacity-100 transition duration-300 font-semibold transform translate-y-0.5 flex items-center">
          {isExpanded ? "閉じる" : "すべて表示"} <ChevronRight className={`w-3 h-3 ml-1 transition-transform ${isExpanded ? "rotate-90" : ""}`} />
        </span>
      </h2>

      <div className="relative group/scroll -mx-4 md:-mx-[4%]">
        {!isExpanded && (
          <ChevronLeft 
            className={`absolute left-0 top-0 bottom-0 z-50 bg-black/50 hover:bg-black/70 w-10 md:w-12 h-full cursor-pointer transition-all duration-300 hidden md:flex items-center justify-center text-white opacity-0 group-hover/row:opacity-100`}
            onClick={() => scroll("left")} 
          />
        )}

        <div 
          ref={scrollRef} 
          className={
            isExpanded 
              ? "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-2 gap-y-12 px-4 md:px-[4%] pb-8 pt-4" 
              : "flex gap-2 md:gap-4 overflow-x-auto no-scrollbar px-4 md:px-[4%] pb-8 pt-4 scroll-smooth"
          }
        >
          {items.map((item, index) => 
            isRanking ? (
              <RankCard key={item.id} item={item} rank={index + 1} onClick={onCardClick} isInMyList={myList.has(item.id)} toggleMyList={toggleMyList} isGrid={isExpanded} />
            ) : (
              <StandardCard key={item.id} item={item} onClick={onCardClick} isInMyList={myList.has(item.id)} toggleMyList={toggleMyList} isGrid={isExpanded} />
            )
          )}
        </div>

        {!isExpanded && (
          <ChevronRight 
            className={`absolute right-0 top-0 bottom-0 z-50 bg-black/50 hover:bg-black/70 w-10 md:w-12 h-full cursor-pointer transition-all duration-300 hidden md:flex items-center justify-center text-white opacity-0 group-hover/row:opacity-100`}
            onClick={() => scroll("right")} 
          />
        )}
      </div>
    </div>
  );
});

const RankCard = memo(({ item, rank, onClick, isInMyList, toggleMyList, isGrid }) => (
  <div className={`relative cursor-pointer group ${isGrid ? 'w-full aspect-[2/3]' : 'flex-none w-[140px] md:w-[200px] h-[200px] md:h-[280px]'}`} onClick={() => onClick(item)}>
    <div className="absolute -left-3 md:-left-6 bottom-0 z-10 w-1/2 h-full flex items-end justify-end pointer-events-none">
      <svg viewBox="0 0 100 150" className="h-full w-full overflow-visible drop-shadow-2xl">
        <text x="50" y="150" fontSize="155" fontWeight="900" fill="#141414" stroke="#595959" strokeWidth="4" textAnchor="middle" style={{ textShadow: "0 0 10px rgba(0,0,0,0.5)" }}>{rank}</text>
      </svg>
    </div>
    <div className="absolute right-0 top-0 bottom-0 w-[65%] rounded-md overflow-hidden transition-all duration-300 group-hover:scale-110 group-hover:z-30 origin-center bg-[#222] shadow-lg">
      <img src={item.image} alt={item.title} loading="lazy" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
        <div className="bg-white/90 rounded-full p-3 shadow-lg"><Play className="w-6 h-6 text-black fill-black" /></div>
      </div>
    </div>
  </div>
));

const StandardCard = memo(({ item, onClick, isInMyList, toggleMyList, isGrid }) => (
  <div className={`relative aspect-video cursor-pointer group transition-all duration-300 z-10 hover:z-50 hover:scale-125 hover:shadow-2xl origin-center ${isGrid ? 'w-full' : 'flex-none w-[200px] md:w-[280px]'}`} onClick={() => onClick(item)}>
    <div className="w-full h-full rounded-md overflow-hidden bg-[#222] relative">
      <img src={item.heroImage} alt={item.title} loading="lazy" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <h3 className="absolute bottom-2 left-2 right-2 text-white font-bold text-sm drop-shadow-md opacity-100 group-hover:opacity-0 transition-opacity text-center md:text-left">{item.title}</h3>
    </div>
    <div className="absolute inset-0 bg-[#181818] rounded-md shadow-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col -z-10 group-hover:z-20 overflow-hidden">
      <div className="h-[50%] relative">
        <img src={item.heroImage} alt={item.title} loading="lazy" className="w-full h-full object-cover" />
      </div>
      <div className="p-3 flex flex-col justify-between flex-1">
        <div className="flex items-center gap-2 mb-2">
          <div className="bg-white rounded-full p-1.5 hover:bg-gray-200 cursor-pointer shadow-sm"><Play className="w-3 h-3 text-black fill-black" /></div>
          <div onClick={(e) => { e.stopPropagation(); toggleMyList(item.id); }} className="border-2 border-gray-400 rounded-full p-1.5 hover:border-white hover:bg-white/10 cursor-pointer text-white">
            {isInMyList ? <Check className="w-3 h-3" /> : <Plus className="w-3 h-3" />}
          </div>
          <div className="border-2 border-gray-400 rounded-full p-1.5 hover:border-white hover:bg-white/10 cursor-pointer ml-auto text-white">
            <ChevronDown className="w-3 h-3" />
          </div>
        </div>
        <div>
          <div className="flex items-center gap-2 text-[10px] text-gray-300 font-semibold mb-1">
            <span className="text-green-400">{item.match}</span>
            <span className="border border-gray-500 px-1 rounded-sm">{item.rating}</span>
            <span>{item.duration}</span>
          </div>
          <div className="flex gap-1 flex-wrap text-[10px] text-gray-400">{item.genre}</div>
        </div>
      </div>
    </div>
  </div>
));

const DetailModal = memo(({ item, onClose, isInMyList, toggleMyList, isLiked, toggleLike }) => {
  if (!item) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-black/70 backdrop-blur-sm p-0 md:p-8 overflow-y-auto animate-fade-in" onClick={onClose}>
      <div className="bg-[#181818] w-full max-w-5xl rounded-lg overflow-hidden shadow-2xl animate-scale-in relative my-8" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 z-20 bg-[#181818]/80 rounded-full p-2 hover:bg-[#333] transition backdrop-blur-sm"><X className="w-6 h-6 text-white" /></button>
        <div className="relative h-[350px] md:h-[550px]">
          <div className="absolute inset-0">
            <img src={item.heroImage || item.image} alt={item.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#181818] via-transparent to-transparent"></div>
          </div>
          <div className="absolute bottom-8 left-6 md:bottom-12 md:left-12 max-w-2xl z-10">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-gray-200 text-sm font-bold uppercase tracking-widest drop-shadow-md">ORIGINAL TITLE: {item.originalTitle}</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-white mb-6 drop-shadow-2xl tracking-tight">{item.title}</h2>
            <div className="flex flex-wrap items-center gap-4">
              <a href={item.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-white text-black px-6 py-2 md:py-3 rounded font-bold hover:bg-white/90 transition active:scale-95 shadow-lg">
                <Play className="fill-black w-6 h-6 md:w-8 md:h-8" />
                <span className="text-base md:text-lg whitespace-nowrap">{item.adminUrl ? "顧客アプリ" : "サイトを見る"}</span>
              </a>
              {item.adminUrl && (
                <a href={item.adminUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-[rgba(109,109,110,0.7)] text-white px-6 py-2 md:py-3 rounded font-bold hover:bg-[rgba(109,109,110,0.5)] transition active:scale-95 shadow-lg backdrop-blur-sm">
                  <span className="text-base md:text-lg whitespace-nowrap">管理アプリ</span>
                </a>
              )}
              <button onClick={() => toggleMyList(item.id)} className="border-2 border-gray-400 rounded-full p-2 md:p-3 hover:border-white hover:bg-white/10 transition active:scale-90 group">
                {isInMyList ? <Check className="w-6 h-6 text-white" /> : <Plus className="w-6 h-6 text-white" />}
              </button>
              <button onClick={() => toggleLike(item.id)} className="border-2 border-gray-400 rounded-full p-2 md:p-3 hover:border-white hover:bg-white/10 transition active:scale-90 group">
                <ThumbsUp className={`w-6 h-6 transition ${isLiked ? "text-white fill-white" : "text-white"}`} />
              </button>
            </div>
          </div>
        </div>
        <div className="p-6 md:p-12 grid md:grid-cols-[2fr_1fr] gap-8 text-white bg-[#181818]">
          <div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-6 text-sm md:text-lg font-medium">
              <span className="text-green-400 font-bold">{item.match}</span>
              <span className="text-gray-300">{item.duration}</span>
              <span className="border border-gray-500 px-2 text-xs text-gray-300 leading-tight py-0.5">{item.rating}</span>
              <span className="text-gray-300">{item.genre}</span>
            </div>
            <p className="text-base md:text-xl leading-relaxed mb-8 text-white font-normal">{item.description}</p>
            <hr className="border-gray-700 mb-6" />
            <h4 className="text-xl font-bold text-white mb-4">プロジェクトの背景と成果</h4>
            <p className="text-gray-300 text-base leading-relaxed">
              ユーザーの潜在的な課題を抽出し、直感的なUIとスムーズな体験（UX）を通じて解決に導くことを目指しました。企画立案からデザイン、実装までのディレクションを一貫して行い、機能性と美しさを両立させたプロジェクトです。
            </p>
          </div>
          <div className="text-sm space-y-4 pt-2">
            <div><span className="text-gray-500 block mb-1">特徴 (アピールポイント):</span><span className="text-gray-200 text-xs md:text-sm">{item.cast.join(", ")}</span></div>
            <div><span className="text-gray-500 block mb-1">ジャンル:</span><span className="text-gray-200 text-xs md:text-sm">{item.tags.join(", ")}</span></div>
            <div><span className="text-gray-500 block mb-1">ディレクション / UIUX:</span><span className="text-gray-200 text-xs md:text-sm">相澤 (Aizawa)</span></div>
          </div>
        </div>
      </div>
    </div>
  );
});

/* -------------------------------------------------------------------------- */
/*                                Main App                                    */
/* -------------------------------------------------------------------------- */

export default function App() {
  const [viewState, setViewState] = useState("intro");
  const [scrolled, setScrolled] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [myList, setMyList] = useState(new Set());
  const [likedItems, setLikedItems] = useState(new Set());
  const [isMuted, setIsMuted] = useState(true);
  const [activeCategory, setActiveCategory] = useState("ホーム");

  const CATEGORIZED_DATA = useMemo(() => ({
    all: PORTFOLIO_DATA,
    system: PORTFOLIO_DATA.filter(i => i.category === "System"),
    web: PORTFOLIO_DATA.filter(i => i.category === "Web"),
    appGame: PORTFOLIO_DATA.filter(i => i.category === "App" || i.category === "Game"),
    ranking: PORTFOLIO_DATA.slice(0, 10)
  }), []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const createToggleSet = useCallback((setFn) => (id) => {
    setFn(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }, []);

  const toggleMyList = useMemo(() => createToggleSet(setMyList), [createToggleSet]);
  const toggleLike = useMemo(() => createToggleSet(setLikedItems), [createToggleSet]);
  
  const rankScrollRef = useRef(null);
  const scrollRank = (direction) => {
    if (rankScrollRef.current) {
      const scrollAmount = window.innerWidth * 0.8;
      rankScrollRef.current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
    }
  };

  if (viewState === "intro") return <IntroAnimation onComplete={() => setViewState("profile")} />;
  if (viewState === "profile") return <ProfileSelect onSelect={() => { setViewState("loading"); setTimeout(() => setViewState("browse"), 1500); }} />;
  if (viewState === "loading") return <LoadingScreen />;

  return (
    <div className="bg-[#141414] min-h-screen font-sans text-white overflow-x-hidden selection:bg-red-600 selection:text-white pb-8">
      <style>{`
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-fade-in { animation: fade-in 0.5s ease-out forwards; }
        @keyframes fade-in-up { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in-up { animation: fade-in-up 0.8s ease-out forwards; }
        @keyframes billboard-fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-billboard-fade-in { animation: billboard-fade-in 1s ease-in-out forwards; }
        @keyframes scale-in { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scale-in 0.2s ease-out forwards; }
        @keyframes slow-zoom { from { transform: scale(1); } to { transform: scale(1.1); } }
        .animate-slow-zoom { animation: slow-zoom 10s linear alternate infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <Navbar scrolled={scrolled} activeCategory={activeCategory} onCategoryChange={setActiveCategory} />

      {activeCategory === "ホーム" ? (
        <>
          <HeroBillboard items={CATEGORIZED_DATA.all} onInfoClick={setSelectedItem} isMuted={isMuted} toggleMute={() => setIsMuted(!isMuted)} />
          <div className="relative z-10 -mt-20 md:-mt-24 space-y-4 md:space-y-8 bg-gradient-to-b from-transparent via-[#141414] to-[#141414]">
            <section className="relative z-20 mt-4 mb-8 px-4 md:px-[4%] pt-4 md:pt-8 group/row">
              <h2 className="text-white text-lg md:text-2xl font-bold mb-2 md:mb-4 drop-shadow-md">
                採用担当者様へのおすすめ TOP 10 <span className="text-xs md:text-sm font-bold text-[#e50914] ml-2 tracking-wider border border-gray-600 px-2 py-0.5 rounded-sm bg-black/50">PORTFOLIO</span>
              </h2>
              
              <div className="relative group/scroll -mx-4 md:-mx-[4%]">
                <ChevronLeft 
                  className="absolute left-0 top-0 bottom-0 z-50 bg-black/50 hover:bg-black/70 w-10 md:w-12 h-full cursor-pointer transition-all duration-300 hidden md:flex items-center justify-center text-white opacity-0 group-hover/row:opacity-100"
                  onClick={() => scrollRank("left")} 
                />
                
                <div ref={rankScrollRef} className="flex gap-2 md:gap-4 overflow-x-auto no-scrollbar px-4 md:px-[4%] pb-4 scroll-smooth">
                  {CATEGORIZED_DATA.ranking.map((item, index) => (
                    <RankCard key={item.id} item={item} rank={index + 1} onClick={setSelectedItem} isInMyList={myList.has(item.id)} toggleMyList={toggleMyList} isGrid={false} />
                  ))}
                </div>

                <ChevronRight 
                  className="absolute right-0 top-0 bottom-0 z-50 bg-black/50 hover:bg-black/70 w-10 md:w-12 h-full cursor-pointer transition-all duration-300 hidden md:flex items-center justify-center text-white opacity-0 group-hover/row:opacity-100"
                  onClick={() => scrollRank("right")} 
                />
              </div>
            </section>
            <Row title="業務システム (SaaS)" items={CATEGORIZED_DATA.system} onCardClick={setSelectedItem} toggleMyList={toggleMyList} myList={myList} />
            <Row title="Web・LP制作" items={CATEGORIZED_DATA.web} onCardClick={setSelectedItem} toggleMyList={toggleMyList} myList={myList} />
            <Row title="アプリ・ゲーム" items={CATEGORIZED_DATA.appGame} onCardClick={setSelectedItem} toggleMyList={toggleMyList} myList={myList} />
          </div>
        </>
      ) : (
        <div className="pt-24 md:pt-32 px-4 md:px-[4%] min-h-[80vh] animate-fade-in">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-8 border-l-4 border-[#e50914] pl-4">{activeCategory}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-2 gap-y-12 pb-12">
            {(activeCategory === "業務システム (SaaS)" ? CATEGORIZED_DATA.system : 
              activeCategory === "Web・LP制作" ? CATEGORIZED_DATA.web : 
              CATEGORIZED_DATA.appGame).map(item => (
                <StandardCard key={item.id} item={item} onClick={setSelectedItem} isInMyList={myList.has(item.id)} toggleMyList={toggleMyList} isGrid={true} />
            ))}
          </div>
        </div>
      )}

      <footer className="px-4 md:px-[4%] py-16 text-gray-500 text-sm bg-[#141414] mt-12 max-w-5xl mx-auto border-t border-gray-800">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-3 gap-x-4 mb-4 mt-8">
          {["音声・字幕", "ヘルプセンター", "メディアセンター", "採用情報", "利用規約", "プライバシー", "Cookie設定", "お問い合わせ"].map(text => (
            <span key={text} className="hover:underline cursor-pointer">{text}</span>
          ))}
        </div>
        <button className="border border-gray-500 text-gray-500 px-2 py-1 hover:text-white mb-4 text-xs transition">サービスコード</button>
        <p className="text-[11px]">&copy; 2024 AIZAWA Inc.</p>
      </footer>

      {selectedItem && (
        <DetailModal item={selectedItem} onClose={() => setSelectedItem(null)} isInMyList={myList.has(selectedItem.id)} toggleMyList={toggleMyList} isLiked={likedItems.has(selectedItem.id)} toggleLike={() => toggleLike(selectedItem.id)} />
      )}
    </div>
  );
}
